import type {
  IAdViewConditionReport,
  ICarLeasingAdView,
  ICarLeasingBusinessAdView,
  ICarUsedAdView,
  ICarUsedBusinessAdView,
} from "@finn-no/adview-provider-frontend-types";
import { Trans } from "@lingui/react";
import type { CarAd, MobilityAd } from "@mobility-item-page/types";
import { isCarAd, isMotorbikeAd } from "@mobility-item-page/utilities";

function hasConditionReportObject(
  ad: CarAd,
): ad is ICarUsedAdView | ICarUsedBusinessAdView | ICarLeasingAdView | ICarLeasingBusinessAdView {
  return "condition_report" in ad;
}

type Props = {
  ad: MobilityAd;
};

const Condition = ({ ad }: Props) => {
  const isCar = isCarAd(ad);
  const isMotorbike = isMotorbikeAd(ad);

  let conditionReport: IAdViewConditionReport | boolean | undefined;
  let hasConditionLink: boolean;
  let hasNAFReport: boolean;

  if (isCar && hasConditionReportObject(ad)) {
    conditionReport = ad.condition_report;
    if (!conditionReport) return null;
    hasConditionLink = !!conditionReport.link;
    hasNAFReport = hasConditionLink && conditionReport.provider?.id === 1;
    return (
      <>
        <p className="mb-0">
          <Trans
            id="itemPageLayout.safetyElement.condition.info"
            message="The vehicle is sold with an approved condition report. This means that the condition of the vehicle is documented and this
						provides you as the buyer with a confirmation that the vehicle is in the condition you have been promised."
          />
        </p>
        {hasNAFReport && (
          <a href={conditionReport.link} className="block mt-16 md:mt-8" target="_blank" rel="noopener">
            <Trans id="itemPageLayout.safetyElement.condition.NAFTest" message="NAF test" />
          </a>
        )}
        {hasConditionLink && !hasNAFReport && (
          <a href={conditionReport.link} className="block mt-16 md:mt-8" target="_blank" rel="noopener">
            <Trans id="itemPageLayout.safetyElement.condition.conditionReport" message="Condition report" />
          </a>
        )}
      </>
    );
  } else if (isMotorbike) {
    conditionReport = !!ad.condition_report;
    if (!conditionReport) return null;
    return (
      <p className="mb-0">
        <Trans
          id="itemPageLayout.safetyElement.condition.info"
          message="The vehicle is sold with an approved condition report. This means that the condition of the vehicle is documented and this
						provides you as the buyer with a confirmation that the vehicle is in the condition you have been promised."
        />
      </p>
    );
  }
  return null;
};

export default Condition;
